import { render } from "./DashboardBundleLinks.vue?vue&type=template&id=5be9f822&scoped=true"
import script from "./DashboardBundleLinks.vue?vue&type=script&lang=js"
export * from "./DashboardBundleLinks.vue?vue&type=script&lang=js"

import "./DashboardBundleLinks.vue?vue&type=style&index=0&id=5be9f822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be9f822"]])

export default __exports__